import {useState} from 'nuxt/app';
import {computed} from 'vue';
import {useHandleCode} from "~/composables/useHandleCode";
import {useFetchWithJwt} from "~/composables/useFetchWithJwt";
import {useConstantData} from "~/composables/useConstantData";
import {ApiResponse} from "~/types/response";
import {UserResultResponse} from "~/types/user";
import { useLanguage } from "~/composables/useLanguage";


export function useMyInfo() {
	const { lang } = useLanguage();
	const {getItems} = useConstantData();
	const {fetchWithJwt} = useFetchWithJwt();
	const {handleSuccessCode, handleErrorCode} = useHandleCode();

	const userRole = useState<string>('userRole', () => '');//권한
	const id = useState<number>('id', () => -1);//user id
	const loginName = useState<string>('loginName', () => '');//로그인 아이디
	const userName = useState<string>('userName', () => '');//사용자 이름
	const position = useState<string>('position', () => '');//직급
	const contact = useState<string>('contact', () => '');//휴대폰번호
	const emailId = useState<string>('emailId', () => '');//이메일 아이디
	const emailDomain = useState<string>('emailDomain', () => '');//이메일 도메인

	const isReceivingAlarm = useState<number>('isReceivingAlarm', () => 1);
	const selectReceiveAlarmList = computed(() => [
		{value: 1, label : lang.label('receive')},
		{value: 0, label : lang.label('reject')}
	]);


	const fetchMyInfo = async (): Promise<ApiResponse<any>> => {
		return (await fetchWithJwt('/user/myInfo', {
			method: 'GET'
		})) as ApiResponse<any>;
	};
	// ★ 수정된 handlePasswordCheck: boolean 반환
	const handleMyInfo = async () => {
		console.log('[useMyInfo.ts] handleMyInfo 함수 시작');
		const response = await fetchMyInfo();
		if (response?.result === 'success') {
			const data = response.data;

			const constantData = getItems('USER_ROLE');
			console.log('constantData', constantData);

			userRole.value = data.userRole;
			id.value = data.id;
			loginName.value = data.loginName;
			userName.value = data.userName;
			position.value = data.position;
			contact.value = data.contact;

			// email을 '@' 기준으로 분리
			const emailParts = data.email ? response.data.email.split('@') : ['', ''];
			emailId.value = emailParts[0];
			emailDomain.value = emailParts[1];

			isReceivingAlarm.value = data.isReceivingAlarm;
			console.log('[useMyInfo.ts] handleMyInfo 함수 종료');
			return true;
		} else {
			console.log('[useMyInfo.ts] handleMyInfo 함수 종료');
			return false;
		}
	};

	const fetchSaveMyInfo = async (params: Record<string, any>): Promise<ApiResponse<any>> => {
		return (await fetchWithJwt('/user/update', {
			method: 'POST',
			body: JSON.stringify({
				id: id.value,
				password: params.password,
				userName: params.userName,
				position: params.position,
				contact: params.contact,
				email: params.email,
				isReceivingAlarm: params.isReceivingAlarm
			}),
		})) as ApiResponse<any>;
	};
	// ★ 수정된 handlePasswordCheck: boolean 반환
	const handleSaveMyInfo = async (params: Record<string, any>): Promise<boolean> => {
		console.log('[useMyInfo.ts] handleSaveMyInfo 함수 시작');
		const response = await fetchSaveMyInfo(params);

		try {
			if (response?.result === 'success') {
				handleSuccessCode('S00003');
				console.log('[useMyInfo.ts] handleSaveMyInfo 함수 종료');
				return true;
			} else {
				handleErrorCode(response.message);
				console.log('[useMyInfo.ts] handleSaveMyInfo 함수 종료');
				return false;
			}
		} catch (error) {
			console.error('Error in handleSaveMyInfo:', error);
			handleErrorCode('E50001'); // 기본 에러 코드 처리
			console.log('[useMyInfo.ts] handleSaveMyInfo 함수 종료');
			return false;
		}
	};

	// 회원 탈퇴 API 호출
	const fetchDeleteUser = async (id: number): Promise<ApiResponse<UserResultResponse>> => {
		return await fetchWithJwt(`/user/delete/${id}`, {
			method: 'DELETE',
		}) as ApiResponse<UserResultResponse>;
	}

	// 회원 탈퇴
	const handleUserWithdrawal = async (userId: number) => {
		console.log('[useMyInfo.ts] handleUserWithdrawal 함수 시작');
		try {
			const response = await fetchDeleteUser(userId);
			if (response && response.result === 'success') {
				handleSuccessCode('S00004');
			} else if (response && response.result === "fail") {
				handleErrorCode(response.message);
			}
		} catch (error) {
			handleErrorCode('E50000');
			console.error("❌ 회원 탈퇴 중 오류 발생:", error);
		}
		console.log('[useMyInfo.ts] handleUserWithdrawal 함수 종료');
	}

	return {
        id,//user id
		loginName,//로그인 아이디
		userName,//사용자 이름
		position,//직급
		contact,//휴대폰번호
		emailId,//이메일 아이디
		emailDomain,//이메일 도메인

		isReceivingAlarm,//알림 수신 여부
		selectReceiveAlarmList,

		handleMyInfo,
		handleSaveMyInfo,
		handleUserWithdrawal// 회원 탈퇴
	};
}
